import React from 'react';
import styles from './motionAdsPreviewImages.module.scss';

export const MotionAdsPreviewImages = ({ imageSetNumber }) => {
    return (
        <div className={styles['wrapper']}>
            <img
                src={`${process.env.ASSET_PREFIX}/previewsDrawerAssets/motionAds-static-${imageSetNumber}.jpeg`}
                alt="motionAds-preview-card"
            />
        </div>
    );
};
